import { render, staticRenderFns } from "./selected-area.vue?vue&type=template&id=415de8fa&scoped=true"
import script from "./selected-area.vue?vue&type=script&lang=js"
export * from "./selected-area.vue?vue&type=script&lang=js"
import style0 from "./selected-area.vue?vue&type=style&index=0&id=415de8fa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415de8fa",
  null
  
)

export default component.exports